import styled from "styled-components";

const SpotName = styled.div`
  font-size: 34px;
  font-weight: 300;
  text-transform: capitalize;
`;

export default SpotName;
